/* global axios */
import ApiClient from './ApiClient';

class AccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  createAccount(data) {
    return axios.post(`${this.apiVersion}/accounts`, data);
  }

  show(id) {    
    return axios.get(`${this.apiVersion}/accounts/${id}`);
  }

  subaccounts(params = {}) {
    return axios.get(`${this.url}subaccounts`, { params });
  }
  searchSubaccounts(page = 1, sortAttr = '', search = '') {
    let params = `page=${page}&sort=${sortAttr}`;
    if (search) {
      params = `${params}&q=${search}`;
    }
    let requestURL = `${this.url}subaccounts/search?${params}`;
    return axios.get(requestURL);
  }
}

export default new AccountAPI();
